import { Item } from '@react-stately/collections'
import { ComboBox, ComboBoxProps } from 'components/ComboBox/ComboBox'
import { FONT_WEIGHTS } from 'components/VisualStudioPlayground/Shapes/TextBoxShape/constants'
import { useAvailableWeights } from 'components/VisualStudioPlayground/VisualEditor/hooks/useAvailableWeights'
import { FontFamilyType, FontWeightType } from 'components/VisualStudioPlayground/VisualEditor/Types'
import { observer } from 'mobx-react-lite'

interface Props extends Partial<Omit<ComboBoxProps, 'onSelectionChange' | 'onChange'>> {
  fontFamily?: FontFamilyType
  onChange: (weight: FontWeightType) => any
  weight: FontWeightType
  italic: boolean
}

export const FontWeight = observer(
  ({ onChange, weight, fontFamily = 'Cardo', size = 'lg', italic, ...props }: Props) => {
    const availableWeights = useAvailableWeights(
      { type: 'shared', value: fontFamily },
      { type: 'shared', value: italic },
    )

    return (
      <ComboBox
        aria-label="Font Weight"
        menuTrigger="focus"
        onSelectionChange={(weight) => {
          if (!weight) return
          onChange(parseInt(weight as string, 10) as FontWeightType)
        }}
        size={size}
        defaultInputValue={FONT_WEIGHTS[weight]}
        selectedKey={weight.toString()}
        {...props}
      >
        {availableWeights.map((weight) => {
          const textValue = FONT_WEIGHTS[weight]
          return (
            <Item key={weight} textValue={textValue}>
              <span style={{ fontWeight: weight }}>{textValue}</span>
            </Item>
          )
        })}
      </ComboBox>
    )
  },
)
